import classNames from 'classnames'
import React, { type JSX } from 'react'

import { Heading6 } from '@ui/Typography'
import { ActionIcon } from '@ui/components/ActionIcon'
import { InfoIcon } from '@ui/icons/Info.icon'

import { isFunction } from '@utils/isFunction'

import { Box } from '@shared/components/Box'

import styles from './AccountSettingsPage.module.scss'

type RenderTitleType = React.ReactNode | (() => React.ReactNode)

interface Props {
  children: React.ReactNode
  title?: string
  icon?: JSX.Element
  infoToggle?: () => void
  isList?: boolean
  className?: string
  renderTitle?: RenderTitleType
}

const Title = ({ renderTitle }: { renderTitle: RenderTitleType }) => {
  if (renderTitle && isFunction(renderTitle)) {
    return <>{renderTitle()}</>
  }

  if (renderTitle) {
    return <>{renderTitle}</>
  }
}

export const AccountSettingsBox = (props: Props): JSX.Element => {
  const {
    children,
    title,
    icon,
    infoToggle,
    isList,
    className,
    renderTitle = <Heading6 medium>{title}</Heading6>,
  } = props

  return (
    <div className={classNames(styles.box, className)}>
      <div className={styles.boxTitle}>
        {icon}
        <Box flex align='center'>
          <Title renderTitle={renderTitle} />
          <Box ml='x4' maxHeight='20px'>
            {infoToggle && <ActionIcon icon={InfoIcon} size='x20' onClick={infoToggle} />}
          </Box>
        </Box>
      </div>
      {isList ? <ul className={styles.boxList}>{children}</ul> : children}
    </div>
  )
}
